import React from 'react';

import { Layout } from 'components/Layout';
import { StrapiArticle } from 'types/strapiService/types';
// import { getStrapiImageUrl } from 'lib/strapi/getStrapiImageUrl';
import Info from 'components/views/Article/Info';
import { Proof } from 'components/sections/Proof';
import { proofBuy } from 'content/mocked/proof';
import { Gutter } from 'components/Gutter';
// import { MagazineArticle } from 'components/MagazineArticle';
import { getMarketplaceAdsParams } from 'utils/marketplaceAdsFilter';
import { useVehicleData } from 'lib/api/swr/useVehiclesData';
import useMediaQuery from 'utils/useMediaQuery';
import { Banner } from 'components/Banner';
import { ArticleCalculator } from 'components/ArticleCalculator';

import styles from './Article.module.scss';
// import { CalculatorWrapper } from './CalculatorWrapper';

interface Props {
  article: StrapiArticle;
  // mostPopularArticles: StrapiArticle[] | null;
}

interface MarketPlaceFilters {
  filter: string;
  value: string;
}

const components = {
  info: Info,
  // calculator: CalculatorWrapper,
  // image: Image,
  // 'registration-number-card': CardNumberCard,
};

export const Article: React.FC<Props> = ({ article }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const marketPlaceFilters: MarketPlaceFilters[] = [];
  if (article.attributes.filter) {
    article.attributes.filter.entry.forEach((item) => {
      marketPlaceFilters[item.filter] = item.value;
    });
  }
  const marketplaceAdsParams = getMarketplaceAdsParams({
    perPage: 20,
    filters: {
      tag: '',
      ...marketPlaceFilters,
    },
  });
  const { data: marketplaceAds } = useVehicleData(marketplaceAdsParams);
  const calculatorType = article.attributes.calculator?.type;

  return (
    <Layout>
      <div className={styles.image}>
        {/*
       <Image
          src={getStrapiImageUrl(article.attributes.seo.shareImage.data.attributes.url)}
          width={1344}
          height={760}
        />
      
      */}
      </div>
      <div className={styles.container}>
        <div className={styles.columns}>
          <div className={styles.content}>
            {article?.attributes?.content?.map((item) => {
              // eslint-disable-next-line no-underscore-dangle
              const componentName = item?.__component?.split('.')[1];
              // @ts-ignore
              const Component = components[componentName];
              if (!Component) return null;

              const category = article?.attributes.categories?.data.length
                ? article.attributes.categories.data[0]
                : null;

              const componentProps = componentName === 'info' ? { ...item, category } : item;

              return <Component {...componentProps} />;
            })}

            {
              // only display release banner on blipp förklarar
              // article?.attributes?.categories?.data[0].id === 1 &&
              false && (
                <Gutter>
                  <Banner
                    headline="Företagare med hög leasingkostnad?"
                    content="Med Blipp kan du lägga om ditt nuvarande leasingavtal på din företagsbil och se över dina kostnader.
Skicka in din ansökan så återkommer vi med ett förslag på en ny leasing."
                    link="/foretag/release"
                  />
                </Gutter>
              )
            }
          </div>
          {isMobile &&
            article.attributes.filter &&
            article.attributes.filter.entry &&
            article.attributes.filter.entry.length !== 0 &&
            marketplaceAds &&
            marketplaceAds.payload &&
            marketplaceAds.payload.items && (
              <Gutter size="small">
                <Proof
                  subTitle={
                    article.attributes.filter.headline
                      ? article.attributes.filter.headline
                      : 'Till salu på Blipp'
                  }
                  cars={marketplaceAds.payload.items}
                  blurbs={proofBuy.blurbs}
                  urls={proofBuy.urls}
                  buttons={false}
                />
              </Gutter>
            )}
          <div className={styles.articleCalculator}>
            {calculatorType && <ArticleCalculator calculatorType={calculatorType} />}

            {/* article?.attributes?.categories?.data[0].id === 1 &&
              mostPopularArticles &&
              mostPopularArticles.map((popularArticle) => (
                <MagazineArticle
                  variant="small"
                  // @ts-ignore
                  category={popularArticle.attributes.categories.data[0].attributes.name ?? ''}
                  date={popularArticle.attributes.publishedAt}
                  title={popularArticle.attributes.seo.metaTitle}
                  text={popularArticle.attributes.seo.metaDescription}
                  imageSrc={getStrapiImageUrl(
                    popularArticle.attributes.seo.shareImage.data.attributes.url
                  )}
                  // @ts-ignore
                  href={`/${popularArticle.attributes.categories.data[0].attributes.slug}/${popularArticle.attributes.url}`}
                />
              ))
                  */}
          </div>
        </div>
        {!isMobile &&
          article.attributes.filter &&
          article.attributes.filter.entry &&
          article.attributes.filter.entry.length !== 0 &&
          marketplaceAds &&
          marketplaceAds.payload &&
          marketplaceAds.payload.items && (
            <Gutter size="medium">
              <Proof
                subTitle={
                  article.attributes.filter.headline
                    ? article.attributes.filter.headline
                    : 'Till salu på Blipp'
                }
                cars={marketplaceAds.payload.items}
                blurbs={proofBuy.blurbs}
                urls={proofBuy.urls}
                buttons={false}
              />
            </Gutter>
          )}
      </div>
    </Layout>
  );
};
